import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React, { useState } from 'react';
import Button from '../../../shared/components/atoms/button/button';
import NotificationBox from '../../../shared/components/atoms/notification-box/notification-box';
import NotificationService from "../../../shared/services/notification-service";
import { siteUrl } from '../../../shared/utils/siteUrl';
import SharedButton from '../../atoms/shared-button/shared-button';
import './prediction.scss';
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"

const Prediction = props => {
    const { prediction, pageChange, mobile } = props;
    // var news_info=props.dataProp
    const [pageLoad, setPageLoad] = useState(false);
    const [notification, setNotification] = useState(false);
    const [isLog, setisLog] = useState(false)
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const getDate = (date) => {
        var dateForm = new Date(date)
        return monthNames[dateForm.getMonth()] + " " + dateForm.getDate() + ", " + dateForm.getFullYear()
    }
    React.useEffect(() => {
        setPageLoad(true)

        if (localStorage.getItem('TOKEN_INFO') === null) {
            sessionStorage.setItem('NEXT_PAGE', '/magazin/horoscopo/' + prediction.slug)
        } else {
            setisLog(true)
        }
    }, [])
    const activeNotifications = () => {
        if (isLog) {
            var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

            var config = {
                headers: {
                    Authorization: tokenId,
                },
            }

            let payload = {
                active: true,
                notificationType: "horoscopo",
                value: prediction.slug
            }

            NotificationService.activeNotificationSettings(payload, config)
                .then(res => {
                    if (res.status === 200) {
                        setNotification(true)
                        setTimeout(() => {
                            setNotification(false)
                        }, 10000);
                    } else {
                        console.log(res)
                    }
                })
                .catch(e => console.log(e))
        } else {
            window.location.href = siteUrl + '/login'
        }
    }
    const userInfoEncrypt= encryptUserInfo()
    const handleClick=()=>{
        pushDataLayerEvent({
            event: "Interacciones - Horóscopo",
            category: "magazin",
            action: "click",
            label: "activar notificaciones",
            sub_category:'Horóscopo',
            zodiac_sign:prediction.titulo,
            location: window.location.href,
            user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
            log_status: userInfoEncrypt.log_status,
        })
    }
    return (
        <div className="f-Prediction">

            <div>
                {notification && <NotificationBox copy={"Las notificaciones han sido activadas"} />}
                <div className={pageChange ? "f-Prediction-content f-Prediction-content-close" : "f-Prediction-content"}>
                    <div className="f-Prediction-content-left">
                        <div className="f-Prediction-content-left-icon">
                            <span className={prediction.iconoDelSigno}></span>
                        </div>
                        <img alt={prediction.imagenPrediccionDelDia.description} src={pageLoad ? prediction.imagenPrediccionDelDia.file.url : prediction.imagenPrediccionDelDia.fixed.base64} />
                        <h2><span>Frase</span> de la semana</h2>
                        <p>{prediction.descripcionPrediccionDelDia.descripcionPrediccionDelDia}</p>
                    </div>
                    <div className="f-Prediction-content-right">
                        <SharedButton zodiacSign={prediction.titulo} mobile={mobile} />
                        <h1 className="f-Prediction-content-right-sign">{prediction.titulo}</h1>
                        {prediction.semanaDePublicacion ?
                            <span className="f-Prediction-content-right-date">{prediction.semanaDePublicacion}</span> :
                            <span className="f-Prediction-content-right-date">{getDate(prediction.updatedAt)}</span>
                        }
                        <br />
                        {documentToReactComponents(prediction.detallesDeLaPrediccion.json)}
                        <br />
                        <br />
                        <div className="f-Prediction-content-right-picos"></div>
                        <br />
                        <br />
                        <p>¿Quieres recibir tu horóscopo semanal en tu celular?<br /> Activa las notificaciones ahora.</p>
                        <br />
                        <br />

                        <div className="f-Prediction-content-right-button" 
                        onClick={()=>{
                            handleClick()
                            activeNotifications();
                        }}>
                            <Button className="primary-pink short " title="Activar notificaciones" />
                        </div>
                    </div>

                </div>
                <div className="f-Prediction-content-pestana"></div>
                <div className="f-Prediction-content-pestana2"></div>
            </div>
        </div>
    )
}

export default Prediction;
